module.exports = __webpack_public_path__ + "img/add-user.01d03cdc.svg";